export default __webpack_public_path__ + "static/media/bc-kebab-icon-down.d64c0701.svg";